import { cn } from "../lib/cn.js";

export type SpinnerSize = "sm" | "md" | "lg";

export type SpinnerProps = {
  readonly size?: SpinnerSize;
  readonly className?: string;
  readonly label?: string;
};

const SIZE_CLASS: Record<SpinnerSize, string> = {
  sm: "h-3 w-3",
  md: "h-4 w-4",
  lg: "h-6 w-6",
};

export function Spinner({ size = "md", className, label }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label ?? "Loading"}
      className={cn(
        "inline-block animate-spin rounded-full border-2 border-r-transparent",
        SIZE_CLASS[size],
        className,
      )}
    />
  );
}
